<template>
  <section class="emh-side-filters-category-content-template" data-test-id="emh-side-filters-category-content-template">
    <button
      class="emh-side-filters-category-content-template__back-navigation wb-button wb-button--tertiary wb-button--small"
      data-test-id="emh-side-filters-category-content-template__back-navigation"
      :disabled="isLoading"
      @click="navigateBack"
    >
      <wb-icon class="wb-button__icon" :name.attr="'bds/chevron-left/16'" aria-hidden="true" icon-flip-rtl />
      {{ $t('dcp.platform.button.navigation.back') }}
    </button>

    <div class="emh-side-filters-category-content-template__headline-container">
      <wb-icon class="emh-side-filters-category-content-template__headline-icon" :name.attr="icon" />
      <span class="emh-side-filters-category-content-template__headline">
        {{ headline }}
      </span>
    </div>

    <slot />
  </section>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersCategoryContentTemplate',
};
</script>

<script lang="ts" setup>
const props = defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
  headline: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['navigate-back']);

const navigateBack = () => emit('navigate-back');
</script>

<style lang="scss" scoped>
.emh-side-filters-category-content-template {
  &__back-navigation {
    @include wb-spacing('margin-bottom', 'xs');
    @include breakpoint-to(mq4) {
      display: none;
    }

    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__headline-container {
    @include wb-spacing('margin-bottom', 's');

    @include breakpoint-between(mq3, mq4) {
      @include wb-spacing('margin-bottom', 'm');
    }
    min-height: 40px;
    display: flex;
    align-items: center;
  }

  &__headline-icon {
    @include wb-spacing('margin-right', 'xxs');

    &[name='bds/car/24'] {
      --size: 32px;
    }
    &[name='bds/engine/24'] {
      --size: 26px;
    }
  }

  &__headline {
    @include wb-type-heading-s;
    @include wb-spacing('padding-left', 'xxs');
  }
}
</style>
